import { render, staticRenderFns } from "./FiliaForm.vue?vue&type=template&id=27fc07c7&scoped=true&"
import script from "./FiliaForm.vue?vue&type=script&lang=js&"
export * from "./FiliaForm.vue?vue&type=script&lang=js&"
import style0 from "./FiliaForm.vue?vue&type=style&index=0&id=27fc07c7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fc07c7",
  null
  
)

export default component.exports